import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppFrameLoad - the one "the contact frame has loaded: hand its document to X" step (reuse finding #6417). Every frame
// decorator (`AppMediaFill`, `AppMessageAnchors`, `AppKindsFrame`) did the same gate check, null checks and report.

export class AppFrameLoad {
    /** `Handler(document)` when the gate is open and the frame has a document; a throw is reported under `Where`. */
    public static Run = <TDoc>(Frame: { contentDocument: TDoc | null } | null, Handler: (Doc: TDoc) => void, Where: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Frame === null || Frame.contentDocument === null) { return; }
            Handler(Frame.contentDocument);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Where);
        }
    };
}
